import { render, staticRenderFns } from "./CorporateCollaborationMobile.vue?vue&type=template&id=6ef84f7e&scoped=true"
import script from "./CorporateCollaborationMobile.vue?vue&type=script&lang=js"
export * from "./CorporateCollaborationMobile.vue?vue&type=script&lang=js"
import style0 from "./corporateCollaboration.css?vue&type=style&index=0&id=6ef84f7e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef84f7e",
  null
  
)

export default component.exports